module.exports = __webpack_public_path__ + "static/why-agile-workplaces-are-now-more-important-than-ever-238411d1062dbe2accadcca61dfdd77c.png";